import React, { useEffect, useRef, useState } from "react";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  cityActiveInactive,
  deleteCity,
  getAllCities,
} from "./services/city.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { clearStateID, closeStateDrawerOpen } from "../state/stateSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import CreateCity from "./CreateCity";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import { Switch } from "@progress/kendo-react-inputs";
import { clearFilterCity, setCityID, setFilterCity } from "./citySlice";
import ButtonCreate from "../../components/muidrawer/ButtonCreate";
import AppDrawer, { CustomAppDrawer } from "../../components/muidrawer/Drawer";
import ButtonEdit from "../../components/muidrawer/ButtonEdit";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { checkAcessRights } from "../../_helper/helper";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { closeCountryDrawerOpen } from "../country/countrySlice";
import CreateCountry from "../country/CreateCountry";
import CreateState from "../state/CreateState";

const City: React.FC = () => {
  const dispatch = useAppDispatch();
  const isDrawerOpen = useAppSelector((state) => state.muidrawer.open);
  const drawerName = useAppSelector((state) => state.muidrawer.name);
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const stateDrawerOpen = useAppSelector(
    (state) => state.state.stateDrawerOpen
  );
  const countryDrawerOpen = useAppSelector(
    (state) => state.country.countryDrawerOpen
  );
  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(setCurrentPage(0));
    };
  }, []);
  return (
    <>
      <DeleteStateDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            City List
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate label="Add New" drawerName="cityForm" />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <CityGridComponent />
        </GridLayoutItem>
        {isDrawerOpen && drawerName === "cityForm" && (
          <AppDrawer>
            <CreateCity />
          </AppDrawer>
        )}
        {countryDrawerOpen && (
          <CustomAppDrawer
            open={countryDrawerOpen}
            closeDrawerFunction={closeCountryDrawerOpen}
          >
            <CreateCountry />
          </CustomAppDrawer>
        )}
        {stateDrawerOpen && (
          <CustomAppDrawer
            open={stateDrawerOpen}
            closeDrawerFunction={closeStateDrawerOpen}
          >
            <CreateState />
          </CustomAppDrawer>
        )}
      </GridLayout>
    </>
  );
};

const CityGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const CityList = useAppSelector((state) => state.city.CityList);
  const loading = useAppSelector((state) => state.city.loading);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const FilterCity = useAppSelector((state) => state.city.FilterCity);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  useEffect(() => {
    const payload = {
      ...FilterCity,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    dispatch(getAllCities(payload));
  }, [currentPage, pageLimit]);

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteCity"));
      dispatch(setCityID(ID));
    };
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.city_guid}
            name="cityForm"
            themeColor="success"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.city_guid)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.isactive);
    const payload = {
      ...FilterCity,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        city_guid: props.dataItem.city_guid,
        isactive: !IsActive,
      };
      dispatch(cityActiveInactive(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllCities(payload));
        } else {
          dispatch(getAllCities(payload));
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          name="IsActive"
          disabled={isEditAccess ? false : true}
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  const CityFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.city.FilterCity}
        setFilterAction={setFilterCity}
        clearFilterAction={clearFilterCity}
        fetchDataAction={getAllCities}
        pagination={{ case: "capitalize" }}
      />
    ),
    []
  );
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        scrollable="scrollable"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={filter ? filterBy(CityList, filter) : CityList}
        total={CityList[0]?.itemcount || CityList.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onFilterChange={handleFilterChange}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="city_name"
          title="City"
          cells={{
            data: (props: any) => (
              <td>
                <ButtonEdit
                  isEditAccess={isEditAccess}
                  ID={props.dataItem.city_guid}
                  name="cityForm"
                  label={props.dataItem?.city_name}
                />
              </td>
            ),
            filterCell: CityFilterCell,
          }}
        />
        <Column
          field="state_name"
          title="State"
          cells={{
            filterCell: CityFilterCell,
          }}
        />
        <Column
          field="country_name"
          title="Country"
          cells={{
            filterCell: CityFilterCell,
          }}
        />
        <Column
          field="city_guid"
          title="Status"
          cells={{ data: MyActiveInActtiveCommandCell }}
          width={"90px"}
          filterable={false}
          locked={true}
        />
        {(isEditAccess || isDeleteAccess) && (
          <Column
            field="city_guid"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"110px"}
            filterable={false}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteStateDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const CityID = useAppSelector((state) => state.city.CityID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const FilterCity = useAppSelector((state) => state.city.FilterCity);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const handleDeleteAction = async (ID: number | null) => {
    const payload = {
      ...FilterCity,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    if (ID) {
      const response = await dispatch(deleteCity(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllCities(payload));
        dispatch(closeDialog());
        dispatch(clearStateID());
      } else {
        dispatch(getAllCities(payload));
        dispatch(closeDialog());
        dispatch(clearStateID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteCity" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete City?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this City?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(CityID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default City;
